var _a;
import { __spreadArrays } from "tslib";
import { RuleConditionType } from './rule-conditions-type.enum';
import { RuleOperator } from './rule-operators-type.enum';
export var SingleValueOperators = [RuleOperator.IS, RuleOperator.NOT];
export var SetValueOperators = [RuleOperator.IS_SET, RuleOperator.NOT_SET];
export var TextualOperators = __spreadArrays(SingleValueOperators, [RuleOperator.CONTAINS, RuleOperator.NOT_CONTAINS]);
export var OptionalValueTextCompareOperators = __spreadArrays(TextualOperators, SetValueOperators);
export var ListOperators = __spreadArrays([RuleOperator.CONTAINS, RuleOperator.NOT_CONTAINS, RuleOperator.CONTAINS_ALL], SetValueOperators);
export var conditionOperatorsMap = (_a = {},
    _a[RuleConditionType.TICKET_SUBJECT] = TextualOperators,
    _a[RuleConditionType.TICKET_CONTENT] = __spreadArrays(TextualOperators, SetValueOperators),
    _a[RuleConditionType.REPLY_CONTENT] = TextualOperators,
    _a[RuleConditionType.UGC_ITEM_USER_NAME] = TextualOperators,
    _a[RuleConditionType.UGC_ITEM_USER_EMAIL] = TextualOperators,
    _a[RuleConditionType.UGC_ITEM_USER_AUTHENTICATED] = SingleValueOperators,
    _a[RuleConditionType.UGC_ITEM_COUNTRY] = SingleValueOperators,
    _a[RuleConditionType.TICKET_LOCALE] = SingleValueOperators,
    _a[RuleConditionType.TICKET_COMPANY] = SingleValueOperators,
    _a[RuleConditionType.TICKET_STATUS] = SingleValueOperators,
    _a[RuleConditionType.TICKET_BRAND] = SingleValueOperators,
    _a[RuleConditionType.TICKET_CHANNEL] = SingleValueOperators,
    _a[RuleConditionType.TICKET_LABELS] = ListOperators,
    _a[RuleConditionType.TICKET_RELATED_ARTICLES_CATEGORIES] = ListOperators,
    _a[RuleConditionType.TICKET_RELATED_ARTICLES] = [RuleOperator.CONTAINS, RuleOperator.NOT_CONTAINS],
    _a[RuleConditionType.TICKET_PRIORITY] = SingleValueOperators,
    _a[RuleConditionType.UGC_ITEM_EVENT_TIME] = SingleValueOperators,
    _a[RuleConditionType.TICKET_ASSIGNED] = __spreadArrays(SingleValueOperators, SetValueOperators),
    _a[RuleConditionType.TICKET_BOOLEAN_CUSTOM_FIELD] = [RuleOperator.IS],
    _a[RuleConditionType.TICKET_TEXT_CUSTOM_FIELD] = OptionalValueTextCompareOperators,
    _a[RuleConditionType.TICKET_NUMBER_CUSTOM_FIELD] = __spreadArrays(SingleValueOperators, SetValueOperators),
    _a[RuleConditionType.TICKET_SINGLE_SELECT_CUSTOM_FIELD] = __spreadArrays(SingleValueOperators, SetValueOperators),
    _a[RuleConditionType.TICKET_COMPANY_ACCOUNT_MANAGER] = __spreadArrays(SingleValueOperators, SetValueOperators),
    _a[RuleConditionType.TICKET_USER_BOOLEAN_CUSTOM_FIELD] = [RuleOperator.IS],
    _a[RuleConditionType.TICKET_USER_TEXT_CUSTOM_FIELD] = OptionalValueTextCompareOperators,
    _a[RuleConditionType.TICKET_USER_NUMBER_CUSTOM_FIELD] = __spreadArrays(SingleValueOperators, SetValueOperators),
    _a[RuleConditionType.TICKET_USER_SINGLE_SELECT_CUSTOM_FIELD] = __spreadArrays(SingleValueOperators, SetValueOperators),
    _a[RuleConditionType.TICKET_COMPANY_ACCOUNT_MANAGER] = __spreadArrays(SingleValueOperators, SetValueOperators),
    _a[RuleConditionType.TICKET_COMPANY_BOOLEAN_CUSTOM_FIELD] = [RuleOperator.IS],
    _a[RuleConditionType.TICKET_COMPANY_TEXT_CUSTOM_FIELD] = OptionalValueTextCompareOperators,
    _a[RuleConditionType.TICKET_COMPANY_NUMBER_CUSTOM_FIELD] = __spreadArrays(SingleValueOperators, SetValueOperators),
    _a[RuleConditionType.TICKET_COMPANY_SINGLE_SELECT_CUSTOM_FIELD] = __spreadArrays(SingleValueOperators, SetValueOperators),
    _a[RuleConditionType.TICKET_MULTI_LEVEL_CUSTOM_FIELD] = SingleValueOperators,
    _a);
//# sourceMappingURL=rule-operators.i.js.map